import { generatePath, useParams } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { FAQDetail } from "@/components/features/faq-detail";

import { useFaqDetailParams } from "./hooks";

export const FAQDetailPage = () => {
	const { notionID } = useParams();
	const result = useFaqDetailParams();

	if (!result.canRender) {
		if (result.isLoading) {
			return (
				<div className="flex items-center justify-center py-12">
					<div className="text-zinc-600">読み込み中...</div>
				</div>
			);
		}
		return <></>;
	}

	const { hotelID, fileName, type } = result;

	return (
		<PageMeta title="FAQ 詳細" url={generatePath(PATHS.FAQ_DETAIL, { hotelID, notionID: notionID ?? "" })}>
			<FAQDetail hotelID={hotelID} fileName={fileName} type={type} />
		</PageMeta>
	);
};
